module.exports = __webpack_public_path__ + "3fa0161b577bf4c29aef348a987d83ee.jpg";